//import './App.css';

import Footer from "../Footer/Footer";
import Header from "../Header/Header";

import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockImage from "../Block/BlockImage";
import BlockButton from "../Block/BlockButton";
import Block from "../Block/Block";
import { useNavigate } from 'react-router-dom';

function Research() {
  const navigate = useNavigate();
  return (
    <div>
      <Header/>     

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      

      <Block colorTheme="light" gridTemplateColumns="1200px">
        <BlockContent width="100%" textAlign="center" color="grey" fontStyle="italic">
          <BlockTitle fontSize="25px" fontWeight="normal">Compilation of published journal and conference papers, along with other compositions</BlockTitle>
        </BlockContent>
      </Block>

      {window.innerWidth >= 767 ?
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle fontSize="30px">The Impact of Intrinsic Scene Cues on Perceived Color Transfer Quality</BlockTitle>
          <BlockSubtitle>IEEE International Conference on Image Processing (ICIP), Tampere, Finland, Sep. 13 - 17, 2026.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/ICIP2026')}>Learn more</BlockButton>
        </BlockContent>
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ICIP_paper_card.webp'}/>
        </BlockContent>
      </Block>
        :
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ICIP_paper_card.webp'}/>
        </BlockContent>
        <BlockContent>
          <BlockTitle fontSize="30px">The Impact of Intrinsic Scene Cues on Perceived Color Transfer Quality</BlockTitle>
          <BlockSubtitle>IEEE International Conference on Image Processing (ICIP), Tampere, Finland, Sep. 13 - 17, 2026.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/ICIP2026')}>Learn more</BlockButton>
        </BlockContent>
      </Block>
      }


      {window.innerWidth >= 767 ?
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/colortransferlabv2.webp'}/>
        </BlockContent>
        <BlockContent>
          <BlockTitle fontSize="30px">ColorTransferLabV2: A Software Testbed for Multi-Modal Color Transfer, Colorization and Style Transfer</BlockTitle>
          <BlockSubtitle>J. Electron. Imaging 34(5), 051002 (2025), doi: 10.1117/1.JEI.34.5.051002.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/SPIE2025')}>Learn more</BlockButton>
        </BlockContent>
      </Block>
        :
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/colortransferlabv2.webp'}/>
        </BlockContent>
        <BlockContent>
          <BlockTitle fontSize="30px">ColorTransferLabV2: A Software Testbed for Multi-Modal Color Transfer, Colorization and Style Transfer</BlockTitle>
          <BlockSubtitle>J. Electron. Imaging 34(5), 051002 (2025), doi: 10.1117/1.JEI.34.5.051002.</BlockSubtitle>
          <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/SPIE2025')}>Learn more</BlockButton>
        </BlockContent>
      </Block>
      }

      {window.innerWidth >= 767 ?
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle fontSize="30px">Enhanced Illumination Adjustment in 3D Outdoor Reconstructions via Shadow Removal through Color Transfer</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 18 - 19, 2024.</BlockSubtitle>
          <BlockText>Herbert Potechius, Selvam Essaky, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/CVMP2024')}>Learn more</BlockButton>
        </BlockContent>
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/shadowremovalCT.webp'}/>
        </BlockContent>
      </Block>
        :
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/shadowremovalCT.webp'}/>
        </BlockContent>
        <BlockContent>
          <BlockTitle fontSize="30px">Enhanced Illumination Adjustment in 3D Outdoor Reconstructions via Shadow Removal through Color Transfer</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 18 - 19, 2024.</BlockSubtitle>
          <BlockText>Herbert Potechius, Selvam Essaky, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/CVMP2024')}>Learn more</BlockButton>
        </BlockContent>
      </Block>
      }

      {window.innerWidth >= 767 ?
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
          <BlockContent>
            <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ct_volumetricvideos.webp'}/>
          </BlockContent>
          <BlockContent>
            <BlockTitle fontSize="30px">Extension of ColorTransferLab: A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms</BlockTitle>
            <BlockSubtitle>European Light Field Imaging Workshop, Sozopol, Bulgaria, Jun. 25 - 27, 2024.</BlockSubtitle>
            <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
            <BlockButton onClick={() => navigate('/Research/ELFI2024')}>Learn more</BlockButton>
          </BlockContent>
        </Block>
        :
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
          <BlockContent>
            <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ct_volumetricvideos.webp'}/>
          </BlockContent>
          <BlockContent>
            <BlockTitle fontSize="30px">Extension of ColorTransferLab: A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms</BlockTitle>
            <BlockSubtitle>European Light Field Imaging Workshop, Sozopol, Bulgaria, Jun. 25 - 27, 2024. </BlockSubtitle>
            <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
            <BlockButton onClick={() => navigate('/Research/ELFI2024')}>Learn more</BlockButton>
          </BlockContent>
        </Block>
      } 

      {window.innerWidth >= 767 ?
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle fontSize="30px">A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms for Images and 3D Objects</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 30 - Dec. 1, 2023.</BlockSubtitle>
          <BlockText>Herbert Potechius, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/CVMP2023')}>Learn more</BlockButton>
        </BlockContent>
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ColorTransferLab.webp'}/>
        </BlockContent>
      </Block>
        :
        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/ColorTransferLab.webp'}/>
        </BlockContent>
        <BlockContent>
          <BlockTitle fontSize="30px">A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms for Images and 3D Objects</BlockTitle>
          <BlockSubtitle>ACM Siggraph European Conference on Visual Media Production, London, UK, Nov. 30 - Dec. 1, 2023.</BlockSubtitle>
          <BlockText>Herbert Potechius, Gunasekaran Raja, Thomas Sikora, Sebastian Knorr</BlockText>
          <BlockButton onClick={() => navigate('/Research/CVMP2023')}>Learn more</BlockButton>
        </BlockContent>
      </Block>
      }



      {window.innerWidth >= 767 ?
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/pc_colortransfer.webp'}/>
        </BlockContent>
          <BlockContent>
            <BlockTitle fontSize="30px">Color Transfer of 3D Point Clouds For XR Applications</BlockTitle>
            <BlockSubtitle>IEEE International Conference on 3D Immersion, Brussels, Belgium, Dec. 8, 2021. </BlockSubtitle>
            <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
            <BlockButton onClick={() => navigate('/Research/IC3D2021')}>Learn more</BlockButton>
          </BlockContent>
        </Block>
        :
        <Block colorTheme="light" gridTemplateColumns="600px 600px">
          <BlockContent>
            <BlockImage src={process.env.PUBLIC_URL + '/images/research_cards/pc_colortransfer.webp'}/>
          </BlockContent>
          <BlockContent>
            <BlockTitle fontSize="30px">Color Transfer of 3D Point Clouds For XR Applications</BlockTitle>
            <BlockSubtitle>IEEE International Conference on 3D Immersion, Brussels, Belgium, Dec. 8, 2021. </BlockSubtitle>
            <BlockText>Herbert Potechius, Thomas Sikora, Sebastian Knorr</BlockText>
            <BlockButton onClick={() => navigate('/Research/IC3D2021')}>Learn more</BlockButton>
          </BlockContent>
        </Block>
      }
  
      <Footer/>
    </div>
  );
}

export default Research;
